import { call, put, select, takeLatest, takeEvery } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import { getPaginatedReports, upsert } from 'api/ReportingAPI';
import { addNegativeToast } from 'modules/toastContainer';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import { selectReportsTableConfig, selectUserContext, selectDataSource } from './selectors';

export function* fetchFilteredReports({ filters }) {
  try {
    const response = yield call(getPaginatedReports, filters);
    yield put(actions.receivedFilteredPaginatedReports(response.data, filters));
  } catch (error) {
    yield put(actions.fetchFilteredReportError(error));
  }
}

export function* createReport({ data }) {
  try {
    const userContext = yield select(selectUserContext);
    const { componentType, selectedTypeIdsInModal } = yield select(selectDataSource);
    const { projectId, email } = userContext;
    const newReportData = {
      ...data,
      projectId,
      creatorUserId: email,
      componentType,
      componentIds: selectedTypeIdsInModal,
    };
    const response = yield call(upsert, newReportData);
    yield put(actions.reportCreated(response.data));
    const filters = yield select(selectReportsTableConfig);
    yield put(actions.fetchFilteredReportTable(filters));
    yield put(push(`/reports/${response.data.id}`));
  } catch (error) {
    yield put(actions.createReportError(error));
    yield put(
      addNegativeToast(
        `Error: ${error?.response?.data?.status || 'Something went wrong please try again'}`,
      ),
    );
  }
}

addToRootSaga([
  takeLatest(actionTypes.FETCH_FILTERED_REPORTS_REQUEST, fetchFilteredReports),
  takeEvery(actionTypes.CREATE_REPORT_REQUEST, createReport),
]);
